var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-gauge-sentimentals"},[_c('canvas',{staticClass:"myCanvas-sentimentals",attrs:{"id":"sentimentals-gauge"}}),_c('div',{staticClass:"label-gauge-sentimentals"},[_c('span',[_vm._v(_vm._s(_vm.valueOfGraphic)+_vm._s(_vm.$t('sentimentals.gauge_legend'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }